import React from "react";
import ContentLoader, { IContentLoaderProps } from "react-content-loader";
import styles from "./SlotButtonsSkeleton.module.scss";

export const SlotButtonsSkeleton: React.FC<IContentLoaderProps> = (props) => (
  <ContentLoader
    speed={2}
    viewBox="0 0 335 36"
    backgroundColor="var(--gray-02)"
    foregroundColor="var(--gray-04)"
    className={styles.contentLoader}
    {...props}
  >
    <rect x="0" y="0" rx="4" ry="4" width="102" height="36" />
    <rect x="116" y="0" rx="4" ry="4" width="103" height="36" />
    <rect x="233" y="0" rx="4" ry="4" width="102" height="36" />
  </ContentLoader>
);
